module.exports = __webpack_public_path__ + "img/Java_(langage).4eb1819d.png";